import OverheadFactorsPeriod, { IOverheadFactorsPeriodDto } from "./OverheadFactorsPeriod";


export interface IOverheadFactorsPeriodsDto {
    entities: IOverheadFactorsPeriodDto[]
}

export default class OverheadFactorsPeriods {
    entities: OverheadFactorsPeriod[]

    constructor(dto: IOverheadFactorsPeriodsDto) {
        this.entities = dto.entities?.map(e => new OverheadFactorsPeriod(e)) || []
    }
}
